
<script setup lang="ts">
import { onMounted } from 'vue';
import { supportRequest } from './requests/supportRequest';
import { useToast } from 'primevue/usetoast';
import Toast from 'primevue/toast'
import { useThemeStore } from './data/theme';

const { reachBackend } = supportRequest()
const toast = useToast();
const { apply } = useThemeStore()

onMounted(async() => {
    const reach = await reachBackend()
    if(!reach){
        toast.add({ severity: 'error', summary: "Server error", life: 10000 });
    }
    apply()
})
</script>

<template>
    <Toast position="top-center" />
    <RouterView></RouterView>
</template>
<style scoped>

</style>

